module.exports = __webpack_public_path__ + "img/Support + Opportunities Summary.64a58239.png";